import { render } from "./RefinementLabel.vue?vue&type=template&id=6715faa0"
import script from "./RefinementLabel.vue?vue&type=script&lang=js"
export * from "./RefinementLabel.vue?vue&type=script&lang=js"

import exportComponent from "/__w/oscar/oscar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__